<template>
  <div v-if="failedquote && Object.keys(failedquote).length > 0">
    <v-slide-y-reverse-transition hide-on-leave>
      <v-card
        class="card"
      >
        <v-container fluid>
          <v-row class="flex-nowrap">
            <div class="d-flex align-items-center">
              <div
                class="d-flex flex-column justify-center align-center
                    table-right-border table-right-border-light result-columns-align-width failed-quote-img-wrapper"
                :class="$vuetify.breakpoint.smAndDown ? 'pl-4 pr-4' : undefined"
              >
                <img
                  v-if="pluginImage"
                  :src="pluginImage"
                  :alt="qd.brokerFullName"
                  class="failed-quote-img"
                >
                <div
                  v-else
                  class="font-weight-bold text-center"
                  style="max-width:100px;"
                >
                  {{ qd.brokerFullName }}
                </div>
              </div>
              <div class="body-2 d-flex flex-column justify-center pl-4">
                <div v-if="qd.text">
                  {{ qd.text[0] }}
                </div>
                <div v-else>
                  Unfortunately, the provider is unable to quote for drivers with your circumstances
                </div>
              </div>
            </div>
          </v-row>
        </v-container>
      </v-card>
    </v-slide-y-reverse-transition>
  </div>
</template>

<script>

export default {
  name: 'results-failed',
  props: {
    failedquote: {
      required: true,
      type: Object,
    },
  },
  computed: {
    qd () {
      return this.failedquote.details;
    },
    pluginImage: {
      get () {
        if (this.failedquote.details.imageSiteRemote) {
          return this.failedquote.details.imageSiteRemote;
        }
        return this.failedquote.details.image_site_remote;
      },
    },
  },
};
</script>

<style scoped lang="scss">
.hidden-quote-img {
  height: 28px;
  border-left: 1px solid $clr-heather;
  border-right: 1px solid $clr-heather;
}

.failed-quote-img-wrapper {
  height: 35px;
}

.failed-quote-img {
  max-width: 100px;
  max-height: 35px;
}
</style>
